var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1313",
    transform: "translate(-619 -220)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 12",
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    transform: "translate(619 220)",
    style: {
      fill: "#edf6ee"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 140"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 18",
    transform: "translate(633 234)",
    style: {
      fill: "none"
    },
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 137"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121",
    d: "M32.822 4.384a1.366 1.366 0 1 0-.743-1.784 1.365 1.365 0 0 0 .743 1.787",
    transform: "translate(619.488 234.191)",
    style: {
      fill: "#00a61c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 122",
    d: "M40.843 9.51a1.347 1.347 0 0 0 .968-.4 1.367 1.367 0 1 0-1.93 0 1.35 1.35 0 0 0 .962.4",
    transform: "translate(616.086 231.913)",
    style: {
      fill: "#00a61c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 123",
    d: "M45.864 17.008a1.365 1.365 0 0 0 1.263-1.891 1.365 1.365 0 1 0-1.263 1.891",
    transform: "translate(613.81 228.515)",
    style: {
      fill: "#00a61c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 124",
    d: "M26.661 12.647a1.354 1.354 0 0 0-.63.16 1.251 1.251 0 0 0-.35.238c-.06.066-.115.137-.169.207a2.072 2.072 0 0 0-.126.236 1.579 1.579 0 0 0-.077.257 1.483 1.483 0 0 0-.027.268c0 .027.007.054.008.081A11.279 11.279 0 1 1 14.013 2.732a1.363 1.363 0 0 0 .194-2.714A1.25 1.25 0 0 0 13.968 0a14.014 14.014 0 1 0 14.06 14.013 1.366 1.366 0 0 0-1.367-1.367",
    transform: "translate(633.986 234.987)",
    style: {
      fill: "#00402e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 125",
    d: "M24.55 13.556v5.067a1.368 1.368 0 0 0 .4.966l4.2 4.2a1.366 1.366 0 1 0 1.932-1.932l-3.8-3.8v-4.5a1.367 1.367 0 1 0-2.733 0",
    transform: "translate(622.855 229.46)",
    style: {
      fill: "#00a61c"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTime);
export default __webpack_public_path__ + "static/media/ico-time.37fe4741bc83a1ed2db510aa60067b16.svg";
export { ForwardRef as ReactComponent };